export default "__VITE_ASSET__BpOqQfXD__"